export default {
    data() {
        return {
            linkList: [
                {
                    name: '大连',
                    url: 'https://www.dlhsfy.gov.cn/court/html/ssfw/'
                },
                {
                    name: '天津',
                    url: 'https://tjhsfy.tjcourt.gov.cn/article/index/id/MzTLNjAwMSAOAAA.shtml'
                },
                {
                    name: '青岛',
                    url: 'http://qdhsfy.sdcourt.gov.cn/qdhsfy/spgk/sszn31/sszy4575/index.html'
                },
                {
                    name: '南京',
                    url: 'http://www.njhsfy.gov.cn/zh/service/index.html'
                },
                {
                    name: '上海',
                    url: 'https://shhsfy.gov.cn/hsfyytwx/hsfyytwx/sszn1532/sszy1543/index.html?t=20211025212'
                },
                {
                    name: '武汉',
                    url: 'http://whhsfy.hbfy.gov.cn/DocManage/getDocsByFolder?folderNo=10'
                },
                {
                    name: '宁波',
                    url: 'http://www.nbhsfy.cn/col/col1229576692/index.html'
                },
                {
                    name: '厦门',
                    url: 'http://www.xmhsfy.gov.cn/ssfw/sszy/laxz/'
                },
                {
                    name: '广州',
                    url: 'https://www.gzhsfy.gov.cn/web/list?lmdm=ssfw'
                },
                {
                    name: '北海',
                    url: 'https://www.bhhsfy.gov.cn/webCN/list-ssfw.html?lmid=KH0_1008'
                },
                {
                    name: '海口',
                    url: 'http://hsfy.hicourt.gov.cn/preview/channel?columnId=5d4f2a67-04c3-4666-a2c9-3d92f3d25381&&siteId=9234dd90-5c67-4a30-b212-cb6262d80a9c&&isFirst=1'
                }
            ],
            gjfyList:[
                {
                    name: '辽宁',
                    url: 'https://lnsfw.lnsfy.gov.cn/lnssfw/'
                },
                {
                    name: '天津',
                    url: 'https://www.tjcourt.gov.cn/tjfyss/'
                },
                {
                    name: '山东',
                    url: 'https://sd12368.gov.cn/login'
                },
                {
                    name: '江苏',
                    url: 'https://ssfw.jsfy.gov.cn/?eqid=dd6890b20010079b000000026491841d#/index'
                },
                {
                    name: '上海',
                    url: 'http://www.hshfy.sh.cn/shwfy/ssfww/index.jsp'
                },
                {
                    name: '湖北',
                    url: 'https://ssfw.hbfy.gov.cn/#/index'
                },
                {
                    name: '浙江',
                    url: 'https://zjsfgkw.gov.cn/col/col392/index.html'
                },
                {
                    name: '福建',
                    url: 'https://ws.fjcourt.gov.cn/'
                },
                {
                    name: '广东',
                    url: 'https://ssfw.gdcourts.gov.cn/'
                },
                {
                    name: '广西',
                    url: 'http://e.gxcourt.gov.cn/'
                },
                {
                    name: '海南',
                    url: 'https://www.hicourt.gov.cn/news/susongfuwu/list-28.html'
                }
            ],
            swptList:[
                {
                    name:'律师服务平台',
                    url:'https://lspt.court.gov.cn/',
                    code:'lsfwpt'
                },
                {
                    name:'调解平台',
                    url:'http://tiaojie.court.gov.cn/',
                    code:'tjpt'
                },
                {
                    name:'送达平台',
                    url:'http://songda.court.gov.cn/ ',
                    code:'sdpt'
                },
                {
                    name:'人民法院诉讼资产网',
                    url:'https://www.rmfysszc.gov.cn/',
                    code:'rmfysszcw'
                },
                {
                    name:'审判流程信息公开',
                    url:'https://splcgk.court.gov.cn/gzfwww/',
                    code:'splcxxgk'
                },
                {
                    name:'执行信息公开',
                    url:'http://zxgk.court.gov.cn/',
                    code:'zxxxgk'
                },
                {
                    name:'裁判文书公开',
                    url:'https://wenshu.court.gov.cn/',
                    code:'cpwsgk'
                },
                {
                    name:'庭审直播公开',
                    url:'http://tingshen.court.gov.cn/',
                    code:'tszbgk'
                }

            ]
        };
    },
    methods:{
        // 打开外链
        handleOpenLink(item) {
            if (item.url) {
                window.open(item.url);
            }
        }
    }
};
